var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 266,
    height: 266,
    viewBox: "0 0 266 266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bittorrent_3",
    "data-name": "bittorrent@3",
    transform: "translate(-1478 -7601)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_275",
    "data-name": "Ellipse 275",
    cx: 133,
    cy: 133,
    r: 133,
    transform: "translate(1478 7601)",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20604",
    "data-name": "Group 20604",
    transform: "translate(1512.219 7634.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31501",
    "data-name": "Path 31501",
    d: "M200.9,83.432a98.969,98.969,0,0,0-5.812-18.66,100.768,100.768,0,0,0-9.176-16.928,100.522,100.522,0,0,0-26.82-26.812,104.232,104.232,0,0,0-16.92-9.176A99.6,99.6,0,0,0,21.142,47.844a104.233,104.233,0,0,0-9.176,16.928,98.971,98.971,0,0,0,0,77.289,101.207,101.207,0,0,0,9.176,16.92,100.391,100.391,0,0,0,26.82,26.82,104.283,104.283,0,0,0,16.92,9.176,98.971,98.971,0,0,0,77.289,0,101.211,101.211,0,0,0,16.92-9.176,100.391,100.391,0,0,0,26.82-26.82,104.287,104.287,0,0,0,9.176-16.92A98.971,98.971,0,0,0,200.9,83.432ZM103.618,190.389a86.873,86.873,0,1,1,86.873-86.873A86.876,86.876,0,0,1,103.618,190.389Z",
    transform: "translate(-4.109 -3.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31502",
    "data-name": "Path 31502",
    d: "M79.225,149.2h2.348a4.625,4.625,0,0,0,1.216-.108H82.9a4.222,4.222,0,0,0,1.116-.1h.308a2.843,2.843,0,0,0,.916-.1h.308c.308,0,.616-.1,1.024-.1h.2c.408,0,.816-.108,1.224-.108a4.436,4.436,0,0,0,1.124-.2h.2c.308,0,.616-.1.916-.1h.208c.408-.108.716-.108,1.124-.208a16.337,16.337,0,0,0,2.34-.508h.208c.3-.1.708-.1,1.016-.208h.1c.816-.2,1.532-.408,2.348-.608a91.16,91.16,0,0,1-22.732-2.14c-11.224-2.448-21.924-6.828-31-14.38A62.817,62.817,0,0,1,21.213,81.492,59.344,59.344,0,0,1,35.177,43.564,60.559,60.559,0,0,1,80.241,22.148h2.348V8.592H79.941a76.489,76.489,0,0,0-15.3,1.832,73.524,73.524,0,0,0-14.68,5A75.139,75.139,0,0,0,36.5,23.58,71.76,71.76,0,0,0,24.777,34.8a69.389,69.389,0,0,0-8.46,12.54A71.693,71.693,0,0,0,10.7,60.892a74.109,74.109,0,0,0-2.748,14.18l-.308,4.48V82.2A76.745,76.745,0,0,0,9.481,97.5a73.6,73.6,0,0,0,5,14.688c2.556,5.6,7.144,13.864,13.972,20.084A78.854,78.854,0,0,0,77.385,149.2h1.84Z",
    transform: "translate(21.823 29.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31503",
    "data-name": "Path 31503",
    d: "M86.219,120.71a103.7,103.7,0,0,1-14.988-1.632c-21-3.772-39.052-16.62-45.672-35.988C17.5,59.534,29.839,34.046,53.287,26.3a43.382,43.382,0,0,1,13.864-2.248A46.862,46.862,0,0,1,84.7,27.518l5.7-12.132q-2.573-1.032-5.2-1.932A60.061,60.061,0,0,0,67.151,10.7a57.589,57.589,0,0,0-38.128,14.58,58.453,58.453,0,0,0-7.644,8.26,55.456,55.456,0,0,0-5.812,9.484A58.069,58.069,0,0,0,12.911,87.37a56.372,56.372,0,0,0,12.24,20.292,65.717,65.717,0,0,0,17.836,13.256c7.344,3.872,16.42,5.912,25.9,7.244a164.867,164.867,0,0,0,19.068,1.016c4.18-1.532,5.912-2.248,8.16-3.164,1.94-.916,3.872-1.832,5.812-2.956s2.248-1.332,5.5-3.464a5.657,5.657,0,0,0,.816-.616c-11.216,1.94-14.072,1.832-22.024,1.732Z",
    transform: "translate(37.054 45.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31504",
    "data-name": "Path 31504",
    d: "M96.22,90.631c-3.164.2-7.652.5-12.748.5-9.076,0-20.192-.808-29.668-3.972C39.115,82.271,25.251,69.731,25.251,54.227A27.94,27.94,0,0,1,77.56,40.563l12.132-6.012a39.418,39.418,0,0,0-7.244-9.684,41.4,41.4,0,0,0-70.66,29.26,40.8,40.8,0,0,0,3.58,16.52A49.659,49.659,0,0,0,24.235,83.8a62.35,62.35,0,0,0,25.388,16.1c9.276,3.056,22.94,4.18,36.2,3.264a75.883,75.883,0,0,0,11.108-1.632,76.506,76.506,0,0,0,12.24-12.132C106,89.715,100.192,90.323,96.22,90.631Z",
    transform: "translate(52.141 59.97)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtt);
export default __webpack_public_path__ + "static/media/btt.6dab75b4834364bfd73f22a32b72bbad.svg";
export { ForwardRef as ReactComponent };